module.exports = __webpack_public_path__ + "static/media/authBack.63ba5f26.png";